import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import BallIcon from '../../assets/BallIcon';
import EditIcon from '../../assets/EditIcon';
import EditIconDark from '../../assets/EditIconDark';
import useBgColorStore from '../../store/bgColor';
import PilotHoursCard from './PilotHoursCard';
import Accordion from '../../components/common/Accordian';
import { IPilotSummary } from '../../type/pilotSummary';
import { formatDateToDDMMYYYY, getAdjustedDate } from '../../utils/dateUtils';

interface PilotHourList {
  pilotSummary: IPilotSummary[];
}

export default function PilotHoursList({ pilotSummary }: PilotHourList) {
  const { bgColor, updateBgColor } = useBgColorStore();
   const dateTime = formatDateToDDMMYYYY(getAdjustedDate());
  return (
    <>
      <div className="mt-4">
        <Accordion
          title={`Pilot Hours ${dateTime}`}
          iconOpen={
            <div>
              <div className="block dark:hidden">
                <AccordianDownIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianDownIconDark />
              </div>
            </div>
          }
          iconClose={
            <div>
              <div className="block dark:hidden">
                <AccordianUpIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianUpIconDark />
              </div>
            </div>
          }
          bgColor={`${bgColor}`}
        >
          {pilotSummary.map((res) => {
            return (
              <>
                <Accordion
                  key={1}
                  title={res?.staffName}
                  bgColor="bg-backgroundColor-darkThemeColor"
                  status={''}
                >
                  <PilotHoursCard
                    rests={res?.restDays}
                    sevenDays={res?.hours7Display}
                    fourteenDays={res?.hours14Display}
                    hours7Style={res?.hours7Style}
                    hours14Style={res?.hours14Style}
                    restStyle={res?.restStyle}
                    
                  />
                </Accordion>
              </>
            );
          })}
        </Accordion>
      </div>
    </>
  );
}
